<script>
  import { onDestroy, onMount } from "svelte";
  import {
    callQueue,
    activeSpec,
    unlockedSpecs,
    currentSpec,
    directContext,
    menuConfig,
    currMenu,
    currentElementLockGroup,
    viewSpecs,
  } from "../../editor/storage.js";
  import { firstLevelMenus } from "../../editor/menuSchema.js";
  import { deepcopy, validateNamePattern } from "../../editor/utility.js";
  import TitleEditor from "../component/titleEditor.svelte";
  import MultiplesHeaderEditor from "../component/multiplesHeaderEditor.svelte";
  import { makeRGBAString } from "../../editor/component/mark.js";
  import { findTitle, unfindTitle } from "../../editor/component/title.js";
  import { getAugmentation } from "../../editor/exploration/augment.js";

  // event functions
  export let inputFocusAction;
  export let inputBlurAction;

  let subMenu;
  let currTitles;
  let currTitleIndex;
  let title_names;
  let multiplesTitle;
  let multiplesField;
  function setValues() {
    currTitles =
      $currentSpec?.fronto?.title?.items?.map((title, ti) => {
        let c = deepcopy(title);
        c.titleIndex = ti;
        return c;
      }) || [];
    title_names = currTitles.map((title) => title.name);
    if ($currentSpec?.fronto?.layout?.composition === "repeated") {
      multiplesTitle = deepcopy(
        $currentSpec?.fronto?.layout?.split?.label || {}
      );
      multiplesField = $currentSpec?.fronto?.layout?.split?.field;
    }
  }
  function createNewTitle() {
    let base =
      currTitles.length !== undefined
        ? currTitles.length
        : $currentSpec?.fronto?.title?.items?.length || 0;
    let name = "title_" + (base || 0);
    let existing_ids = [];
    $viewSpecs.forEach((spec) => {
      existing_ids.push(
        ...(spec.fronto?.title?.items?.map((d) => d.name) || [])
      );
    });
    console.log(existing_ids);
    let cnt = 2;
    while (existing_ids.includes(name)) {
      cnt += 1;
      name = "title_" + (base + cnt);
      console.log(name);
    }
    let rule = {
      category: "manual",
      description: "Add a new title",
      specifier: { role: "view" },
      action: "add",
      option: {
        role: "title",
        title: {
          name,
          text: "Title",
          fontWeight: 700,
          fontSize: 18,
        },
      },
    };
    callQueue.update((queue) => {
      queue.add([rule], $unlockedSpecs).apply();
      return queue;
    });
  }

  function moveTitle(i, dir) {
    if (["up", "down"].includes(dir)) {
      let rule = {
        category: "manual",
        description: "Move title item " + dir + "ward",
        specifier: { role: "title" },
        action: "swap",
        option: {
          from: { index: i },
          to: { index: i + (dir == "up" ? -1 : 1) },
        },
      };
      callQueue.update((queue) => {
        queue.add([rule], $unlockedSpecs).apply();
        return queue;
      });
    }
  }
  function updateTitle(event, role, title) {
    if (role === "lock") {
      updateLock(event, role, title);
      return;
    } else if (event === "remove") {
      let rule = {
        category: "manual",
        description:
          "Remove title " + (title.name ? title.name : title.titleIndex),
        specifier: { role: "title" },
        action: "remove",
      };
      if (title.name) rule.specifier.id = title.name;
      else if (title.titleIndex) rule.specifier.index = title.titleIndex;
      callQueue.update((queue) => {
        queue.add([rule], $unlockedSpecs).apply({
          afterUpdateAll: () => {
            getAugmentation(
              "title",
              rule,
              null,
              null,
              $currentSpec,
              $unlockedSpecs,
              title
            );
          },
        });
        return queue;
      });
    } else {
      let newValue;
      if (
        [
          "title.name",
          "title.text",
          "title.align",
          "title.orient",
          "title.fontWeight",
        ].includes(role)
      ) {
        newValue = event.target.value;
      } else if (
        [
          "title.lineHeight",
          "title.fontSize",
          "title.width",
          "title.opacity",
          "title.offset",
        ].includes(role)
      ) {
        newValue = parseFloat(event.target.value);
      } else if (role === "title.color") {
        newValue = makeRGBAString(
          event.detail.r,
          event.detail.g,
          event.detail.b,
          event.detail.a
        );
      }
      if (newValue !== undefined || newValue === null) {
        let rule = {
          category: "manual",
          description: "Edit title ",
          specifier: { role: "title" },
          action: "modify",
        };
        if (title.name) rule.specifier.id = title.name;
        else if (title.titleIndex) rule.specifier.index = title.titleIndex;
        if (role === "title.name") {
          rule.description += "name";
          rule.option = { name: newValue };
        } else if (role === "title.text") {
          rule.description += "text";
          rule.option = { text: newValue };
        } else if (role === "title.align") {
          rule.description += "align";
          rule.option = { align: newValue };
        } else if (role === "title.orient") {
          rule.description += "orient";
          rule.option = { orient: newValue };
        } else if (role === "title.fontWeight") {
          rule.description += "font weight";
          rule.option = { fontWeight: newValue };
        } else if (role === "title.lineHeight") {
          rule.description += "line height";
          rule.option = { lineHeight: newValue };
        } else if (role === "title.fontSize") {
          rule.description += "font size";
          rule.option = { fontSize: newValue };
        } else if (role === "title.width") {
          rule.description += "width";
          rule.option = { width: newValue };
        } else if (role === "title.opacity") {
          rule.description += "opacity";
          rule.option = { opacity: newValue };
        } else if (role === "title.offset") {
          rule.description += "offset";
          rule.option = { offset: newValue };
        } else if (role === "title.color") {
          rule.description += "color";
          rule.option = { fontColor: newValue };
        }
        if (rule) {
          callQueue.update((queue) => {
            queue.add([rule], $unlockedSpecs).apply();
            return queue;
          });
        }
      }
    }
  }
  function updateMultiplesHeader(event, role, title) {
    let newValue;
    if (["title.align", "title.fontWeight", "title.anchor"].includes(role)) {
      newValue = event.target.value;
    } else if (["title.fontSize"].includes(role)) {
      newValue = parseFloat(event.target.value);
    } else if (role === "title.color") {
      newValue = makeRGBAString(
        event.detail.r,
        event.detail.g,
        event.detail.b,
        event.detail.a
      );
    }
    if (newValue !== undefined || newValue === null) {
      let rule = {
        description: "Edit multiples title: " + (multiplesField || "") + " ",
        specifier: { role: "view.facet.title" },
        action: "modify",
      };
      if (role === "title.align") {
        rule.description += "align";
        rule.option = { align: newValue };
      } else if (role === "title.fontWeight") {
        rule.description += "font weight";
        rule.option = { fontWeight: newValue };
      } else if (role === "title.anchor") {
        rule.description += "anchor";
        rule.option = { anchor: newValue };
      } else if (role === "title.fontSize") {
        rule.description += "font size";
        rule.option = { fontSize: newValue };
      } else if (role === "title.color") {
        rule.description += "color";
        rule.option = { fontColor: newValue };
      }
      if (rule) {
        rule.category = "manual";
        callQueue.update((queue) => {
          queue.add([rule], $unlockedSpecs).apply();
          return queue;
        });
      }
    }
  }
  function checkName(event) {
    let name = event.target.value;
    return validateNamePattern(name) && !title_names.includes(name);
  }

  function setSubMenu(s, i) {
    subMenu = s;
    currTitleIndex = i;
  }
  function cancelSubMenu() {
    subMenu = undefined;
    currTitleIndex = undefined;
  }

  menuConfig.subscribe((config) => {
    if (config?.subMenu && config?.titleIndex !== undefined) {
      setValues();
      setSubMenu("edit", config.titleIndex);
    } else if (config?.subMenu === "edit-multiples-header") {
      setValues();
      setSubMenu("edit-multiples-header");
    }
  });

  // pipelines
  onMount(() => {
    setValues();
  });
  currentSpec.subscribe(() => {
    setValues();
  });
  onDestroy(() => {
    cancelSubMenu();
  });

  function updateLock(event, role, title) {
    if ($currentElementLockGroup.length > 0) {
      let newValue = event.target.checked;
      if (newValue !== undefined && role && title) {
        let rule = {
          category: "lock",
          description:
            (newValue ? "Lock" : "Unlock") +
            " title " +
            (title.name ? title.name : title.titleIndex),
          specifier: { role: "title" },
          action: "lock",
          option: {
            title: newValue,
          },
        };
        if (title.name) rule.specifier.id = title.name;
        else if (title.titleIndex) rule.specifier.index = title.titleIndex;

        if (rule) {
          callQueue.update((queue) => {
            queue.add([rule], $currentElementLockGroup).apply();
            return queue;
          });
        }
      }
    }
  }
</script>

<section class="second-level-menu">
  <h2>
    {firstLevelMenus["title"]?.title || "Title"}
  </h2>

  {#if $activeSpec == -1}
    <div class="dupo-menu-pane mb-2 warn-msg pt-2" style="margin-top: -0.5rem;">
      <div class="dupo-menu-pane-row">
        <p class="text-sm">Create or select an artboard!</p>
      </div>
    </div>
  {:else if !$unlockedSpecs.includes($currentSpec.uid)}
    <div class="dupo-menu-pane mb-2 warn-msg pt-2" style="margin-top: -0.5rem;">
      <div class="dupo-menu-pane-row">
        <p class="text-sm">Unlock this artboard first!</p>
      </div>
    </div>
  {:else if !subMenu}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <p class="text-sm">Select a title element to edit or add a new one.</p>
      </div>
    </div>
    {#if currTitles}
      <div class="dupo-menu-pane mb-2">
        {#each currTitles as title, i}
          <div class="dupo-menu-pane-form-row">
            <div
              class="menu-second-level menu-with-buttons"
              on:mouseover={() => {
                findTitle($currentSpec.uid, title, "find");
              }}
              on:focus={() => {
                findTitle($currentSpec.uid, title, "find");
              }}
              on:mouseout={() => {
                unfindTitle();
              }}
              on:blur={() => {
                unfindTitle();
              }}
            >
              <div class="text-truncate" style="user-select:none;">
                <i class="bi bi-card-heading me-1" />{title.name ||
                  title.text ||
                  "Title " + (i + 1)}
              </div>
              <div class="dupo-pane-list-button">
                <button
                  type="button"
                  on:click={() => {
                    setSubMenu("edit", i);
                  }}
                  ><i
                    class="bi bi-pencil-fill"
                    alt="{`Edit title ${i + 1}`}}"
                  /></button
                >
                {#if currTitles.length >= 2}
                  <div class="two-row-buttons">
                    {#if i > 0}<button
                        type="button"
                        on:click={() => {
                          moveTitle(i, "up");
                        }}
                        ><i
                          class="bi bi-arrow-up"
                          alt="{`Move up title ${i + 1}`}}"
                        /></button
                      >{:else}<button type="button" disabled
                        ><i class="bi bi-arrow-up" /></button
                      >{/if}{#if i < currTitles.length - 1}<button
                        type="button"
                        on:click={() => {
                          moveTitle(i, "down");
                        }}
                        ><i
                          class="bi bi-arrow-down"
                          alt="{`Move down title ${i + 1}`}}"
                        /></button
                      >{:else}<button type="button" disabled
                        ><i
                          class="bi bi-arrow-down"
                          alt="{`Move down title ${i + 1}`}}"
                        /></button
                      >{/if}
                  </div>
                {/if}
              </div>
            </div>
          </div>
        {/each}
      </div>
      <div class="pane-divider" />
    {/if}
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-form-row">
        <button
          type="button"
          class="menu-second-level"
          on:click={() => createNewTitle()}
          ><i class="bi bi-plus-circle me-1" /> Add a new title</button
        >
      </div>
    </div>
    {#if multiplesTitle}
      <div class="pane-divider" />
      <div class="dupo-menu-pane mb-2">
        <div class="dupo-menu-pane-form-row">
          <div
            class="menu-second-level menu-with-buttons"
            on:mouseover={() => {
              findTitle($currentSpec.uid, "multiples", "find");
            }}
            on:focus={() => {
              findTitle($currentSpec.uid, "multiples"), "find";
            }}
            on:mouseout={() => {
              unfindTitle();
            }}
            on:blur={() => {
              unfindTitle();
            }}
          >
            <div class="text-truncate" style="user-select:none;">
              <i class="bi bi-card-heading me-1" />Multiples title for {multiplesField}
            </div>
            <div class="dupo-pane-list-button">
              <button
                type="button"
                on:click={() => {
                  setSubMenu("edit-multiples-header");
                }}
                ><i
                  class="bi bi-pencil-fill"
                  alt="{`Edit multiples title for ${multiplesField}`}}"
                /></button
              >
            </div>
          </div>
        </div>
      </div>
    {/if}
  {:else if subMenu == "edit" && currTitleIndex !== undefined}
    <TitleEditor
      status="edit"
      title={currTitles[currTitleIndex]}
      {inputFocusAction}
      {inputBlurAction}
      {updateTitle}
      {checkName}
      afterDelete={() => {
        if ($directContext) currMenu.set("selection");
        else {
          unfindTitle();
          cancelSubMenu();
        }
      }}
    />
    <div class="pane-divider" />
    <div class="dupo-menu-pane pb-2">
      <div class="dupo-menu-pane-button-row">
        <button
          type="button"
          on:click={() => {
            if ($directContext) currMenu.set("selection");
            else {
              unfindTitle();
              cancelSubMenu();
            }
          }}
        >
          <i class="bi bi-arrow-left me-1" /> Go back</button
        >
      </div>
    </div>
  {:else if subMenu == "edit-multiples-header" && multiplesField !== undefined}
    <MultiplesHeaderEditor
      title={multiplesTitle}
      field={multiplesField}
      {inputFocusAction}
      {inputBlurAction}
      {updateMultiplesHeader}
    />
    <div class="pane-divider" />
    <div class="dupo-menu-pane pb-2">
      <div class="dupo-menu-pane-button-row">
        <button
          type="button"
          on:click={() => {
            if ($directContext) currMenu.set("selection");
            else {
              unfindTitle();
              cancelSubMenu();
            }
          }}
        >
          <i class="bi bi-arrow-left me-1" /> Go back</button
        >
      </div>
    </div>
  {/if}
</section>
